import { ProductScreenshot } from 'components/ProductScreenshot';
import SettingsLight from "../../../../contents/images/features/data-warehouse/settings-light.png";
import SettingsDark from "../../../../contents/images/features/data-warehouse/settings-dark.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  SettingsLight,
  SettingsDark,
  React
};